<template>
  <div class="gp-main-body-content">
    <!-- <h2 class="flex-v-center typo-h3">Account Settings</h2> -->
    <div class="container">
      <div class="row">
        <Tabs @tabChange="onTabChangeHandler" class="mt-3">
          <template v-slot:GpTab="{activeIndex, handler}">
            <Tab :index="0" :activeIndex="activeIndex" @click="handler">
              <p class="d-flex align-items-center">
                <i class="icon icon-acc-settings" style="margin-right: 10px"></i>
                <span>{{$t("accountSettings.info")}}</span>
              </p>
            </Tab>
            <Tab :index="1" :activeIndex="activeIndex" @click="handler">
              <p class="d-flex align-items-center">
                <i class="icon icon-lock" style="margin-right: 10px"></i>
                <span>{{$t("generals.password")}}</span>
              </p>
            </Tab>

            <Tab :index="1" @click="signOut" class="ml-auto no-border mr-0">
              <p class="d-flex align-items-center">
                <i class="icon icon-login" style="margin-right: 10px; transform: rotate(180deg);"></i>
                <span>{{$t("accountSettings.logout")}}</span>
              </p>
            </Tab>
          </template>

          <!-- List -->
          <template v-slot:GpTabContent="{activeIndex, animate}">
            <Content name="Account" :index="0" :animate="animate" :activeIndex="activeIndex">
              <div class="row mt-5">
                <form @submit.prevent="updateInfo" class="col-12 col-md-9 col-lg-8 col-mlg-6">
                  <p class="typo-body3">{{$t("accountSettings.gpAccountDesc")}}</p>
                  <div class="form-group mt-4">
                    <label class="label">{{ $t("accountSettings.logo") }}</label>
                    <!-- <input class="input-field" type="email" v-model="logo" placeholder="Logo" /> -->
                    <FileUploader
                      class="input-field ml-0"
                      @loaded="addImage"
                      @startLoad="uploading = true"
                      :oldSrc="logo"
                      @delete="deleteImg"
                      apiType="agency"
                    />
                  </div>
                  <div class="form-group ">
                    <label class="label">{{ $t("accountSettings.name") }}</label>
                    <input
                      class="input-field"
                      type="text"
                      v-model="name"
                      required
                      :placeholder="$t('accountSettings.namePlace')"
                    />
                  </div>
                  <div class="form-group">
                    <label class="label">{{ $t("accountSettings.refID") }}</label>
                    <input
                      class="input-field"
                      type="text"
                      v-model="gaff_ref"
                      required
                      :placeholder="$t('agency.settings.refIDPlace')"
                    />
                  </div>
                  <div class="form-group">
                    <label class="label">{{ $t("accountSettings.website") }}</label>
                    <input
                      class="input-field"
                      type="text"
                      v-model="site"
                      :placeholder="$t('accountSettings.websitePlace')"
                    />
                  </div>
                  <div class="form-group">
                    <label class="label">{{ $t("accountSettings.desc") }}</label>
                    <input
                      class="input-field"
                      type="text"
                      v-model="description"
                      :placeholder="$t('accountSettings.descPlace')"
                    />
                  </div>

                  <div class="row mt-6 pb-6">
                    <div class="col-12 col-xs-12 col-sm-6">
                      <!-- <button class="btn btn-success btn-block" type="submit">Save settings</button> -->
                      <ProcessButton
                        class="btn-block"
                        :status.sync="status"
                        type="submit"
                        default="btn-success"
                      >
                        <template #loading>{{$t("generals.saving")}}</template>
                        <template #success>{{$t("generals.save")}} {{$t("generals.success")}}</template>
                        <template #error>{{$t("generals.save")}} {{$t("generals.fail")}}</template>
                        <template #default>{{$t("generals.save")}}</template>
                      </ProcessButton>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6 mt-1 mt-sm-0">
                      <button
                        type="button"
                        class="btn btn-outline btn-block"
                        @click="cancel"
                      >{{$t("generals.cancel")}}</button>
                    </div>
                  </div>
                </form>
              </div>
            </Content>
            <Content name="Password" :index="1" :animate="animate" :activeIndex="activeIndex">
              <div class="row mt-5">
                <form
                  class="col-12 col-sm-9 col-lg-8 col-mlg-6"
                  @submit.prevent="updateStorePassword"
                >
                  <p class="typo-body3">{{$t("accountSettings.passwordDesc")}}</p>

                  <div class="form-group mt-4">
                    <label class="label">{{$t("generals.password")}}</label>
                    <input
                      class="input-field"
                      type="password"
                      autocomplete="new-password"
                      placeholder="password"
                      v-model="password"
                    />
                  </div>

                  <div class="form-group mt-2">
                    <label class="label">{{$t("agency.newPassword")}}</label>
                    <input
                      class="input-field"
                      type="password"
                      autocomplete="new-password"
                      placeholder="new-password"
                      v-model="newPassword"
                    />
                  </div>

                  <div class="form-group mt-2">
                    <label class="label">{{$t("agency.confirmPassword")}}</label>
                    <input
                      class="input-field"
                      type="password"
                      autocomplete="new-password"
                      placeholder="confirm-new-password"
                      v-model="passwordConfirm"
                    />
                  </div>

                  <div class="typo-small text-danger mt-half" v-if="error">{{ error }}</div>

                  <!-- <p
                    class="typo-subtext text-shade6 mb-1"
                  >{{$t("accountSettings.storePasswordFoot")}}</p> -->

                  <div class="row mt-6 pb-6">
                    <div class="col-12 col-xs-12 col-sm-6">
                      <!-- <button type="submit" class="btn btn-success btn-block">Save settings</button> -->
                      <ProcessButton
                        class="btn-block"
                        :status.sync="status"
                        type="submit"
                        default="btn-success"
                      >
                        <template #loading>{{$t("generals.saving")}}</template>
                        <template #success>{{$t("generals.save")}} {{$t("generals.success")}}</template>
                        <template #error>{{$t("generals.save")}} {{$t("generals.fail")}}</template>
                        <template #default>{{$t("agency.changePwd")}}</template>
                      </ProcessButton>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6 mt-1 mt-sm-0">
                      <button
                        type="button"
                        class="btn btn-outline btn-block"
                        @click="cancel"
                      >{{$t("generals.cancel")}}</button>
                    </div>
                  </div>
                </form>
                
              </div>
            </Content>
          </template>
        </Tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs, {
  GpTab as Tab,
  GpTabContent as Content
} from "@/core/shared/GpTabs";
import { ProcessButton, FileUploader } from "@/core/shared";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "AgencySettings",
  components: {
    Tabs,
    Tab,
    Content,
    ProcessButton,
    FileUploader
  },
  data() {
    return {
      prevRoute: null,

      name: "",
      gaff_ref: "",
      site: "",
      description: "",
      logo: "",
      password: "",
      newPassword: "",
      passwordConfirm: "",

      uploading: false,
      error: null
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: state => state.shopInfo,
      hideLanguage: state => state.hideLanguage
    }),
    ...mapState("agency", {
      status: state => state.status,
      agencyInfo: state => state.info
    })
  },
  watch: {
    agencyInfo(newV) {
      this.assignInfo(newV);
    }
  },
  created() {
    this.assignInfo(this.agencyInfo);
  },
  beforeDestroy() {
  },
  methods: {
    ...mapActions("account", {
      updateShopInfo: "accountUpdateShopInfo"
    }),
    ...mapMutations("account", {}),
    changeLang(val) {
      this.doChangeLanguage(val);
    },
    ...mapActions("agency", {
      updateAgencyInfo: "updateAgencyInfo",
      updateAgencyPassword: "updateAgencyPassword",
      signoutAgency: "signoutAgency"
    }),
    goToUpgrade() {
      this.$router.push({ name: "Pricing" });
    },
    ...mapMutations({}),
    onTabChangeHandler() {},
    cancel() {
      if (this.prevRoute.name != null) this.$router.go(-1);
      else this.$router.push({ name: "AgencyDashboard" });
    },
    assignInfo(agencyInfo) {
      this.name = agencyInfo.name;
      this.gaff_ref = agencyInfo.gaff_ref;
      this.site = agencyInfo.site;
      this.description = agencyInfo.description;
      this.logo = (agencyInfo.logo != '' ) ? agencyInfo.logo : this.publicPath + require('@/core/assets/agency-logo.svg');
    },
    updateInfo() {
      this.error = null;
      let diff = 0;
      if (this.name != this.agencyInfo.name)
        diff++;
      if (this.gaff_ref != this.agencyInfo.gaff_ref)
        diff++;
      if (this.site != this.agencyInfo.site)
        diff++;
      if (this.description != this.agencyInfo.description)
        diff++;
      if (this.logo != this.agencyInfo.logo)
        diff++;
      if (diff < 1)
        return;
      this.updateAgencyInfo({
        name: this.name,
        gaff_ref: this.gaff_ref,
        site: this.site,
        description: this.description,
        logo: this.logo
      }).then(() => {
        this.gSnackbarCommit({
          message: this.$t("status.success"),
          type: "success"
        });
      }).catch(err => {
        let msg = err.data && err.data.message || err.response && err.response.data && err.response.data.message || err.response && err.response.message || err.message;
        this.error = msg;
      });
    },
    updateStorePassword() {
      this.error = null;
      let {password, newPassword, passwordConfirm} = this;
      if (!this.checkString(password, 6, 64) || !this.checkString(newPassword, 6, 64) || !this.checkString(passwordConfirm, 6, 64)) {
        this.error = this.$t("agency.pleaseFillPassword");
        return;
      }
      if (newPassword != passwordConfirm) {
        this.error = this.$t("agency.mustMatch");
        return;
      }
      this.updateAgencyPassword({
        current_password: password,
        password: newPassword,
        password_confirmation: passwordConfirm
      }).then(() => {
        this.gSnackbarCommit({
          message: this.$t("status.success"),
          type: "success"
        });
      })
      .catch(err => {
        let msg = err.data && err.data.message || err.response && err.response.message || err.message;
        if (msg == "wrongpass")
          msg = this.$t("agency.wrongPass");
        this.error = msg;
      });
    },
    checkString(str, minLen, maxLen) {
      if (!str)
        return false;
      if (str.trim().length == 0)
        return;
      if (str.length < minLen)
        return false;
      if (str.length > maxLen)
        return false;
      return true;
    },
    addImage(data) {
      this.logo = data;
    },
    deleteImg() {
      this.logo = "";
    },
    signOut() {
      this.signoutAgency().then(() => {
        this.gSnackbarCommit({
          message: this.$t("status.success"),
          type: "success"
        });
        window.location.href = "/agency"
      })
      .catch(() => {
        this.gSnackbarCommit({
          message: this.$t("status.error"),
          type: "error"
        });
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  }
};
</script>

<style lang="scss" scoped>
.gp-tabs {
  overflow: visible;
}
.account-upgrade {
  svg {
    margin-right: 10px;
    width: 16px;
  }
}
::v-deep {
  .btn-file {
    width: 200px;
    .view {
      height: 100%;
    }
  }
  .img-container {
    // width: 100%;
    img {
      width: 100%;
    }
  }
  .gp-tabs-nav-item:not(:last-child) {
    margin-right: 16px;
  }
}
</style>
